import { render } from "./FixedCostAdd.vue?vue&type=template&id=353d0d79"
import script from "./FixedCostAdd.vue?vue&type=script&lang=js"
export * from "./FixedCostAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__